export default "__VITE_ASSET__TMyAsiUt__"